import React from 'react';
import { Select as ANTDSelect } from 'antd';
import './style.css';
const Select = ({ handleChange = () => {}, optionsValue, placeholder, defaultValue, labelInValue = true, ...props }) => {
  return (
    <div className='select'>
      <ANTDSelect
        labelInValue={labelInValue}
        defaultValue={defaultValue || (placeholder ? undefined : optionsValue?.length > 0 ? optionsValue[0] : undefined)}
        onChange={(e) => {
          handleChange(e);
        }}
        placeholder={placeholder}
        options={optionsValue}
        virtual={false}
        getPopupContainer={(trigger) => trigger.parentNode}
        {...props}
      />
    </div>
  );
};
export default Select;